export default "__VITE_ASSET__44099d10__"